module.exports = __webpack_public_path__ + "assets/svg/Icons/32/activity-gray-d71c05.svg";